<script>
    import Button from "./Button.svelte";
    import PrivacyPolicy from "./PrivacyPolicy.svelte";
    import License from "./License.svelte";
    const PRIVACY = "PRIVACY";
    const LICENSE = "LICENSE";
    let optionsRoute = LICENSE;
    function setOptionsRoute(_optionsRoute) {
        optionsRoute = _optionsRoute;
    }
</script>

<div class="flex">
    <aside class="">
        <div class="flex flex-direction-column gap-15 pad-20">
            <div class="flex flex-direction-column gap-15">
                <div class="flex align-items-center gap-20">
                    <Button
                        on:click={() => window.goBack()}
                        type="button"
                        text="🠔 Back"
                        class="sm"
                    />
                    <h1 class="aside-title">{globalThis.i18n("Legal")}</h1>
                </div>
            </div>
            <div class="flex flex-direction-column gap-15">
                <Button
                    on:click={() => setOptionsRoute(LICENSE)}
                    isActive={optionsRoute == LICENSE}
                    type="button"
                    text="EULA"
                    style="text-align:left"
                    doLocalizeText={false}
                />
                <Button
                    on:click={() => setOptionsRoute(PRIVACY)}
                    isActive={optionsRoute == PRIVACY}
                    type="button"
                    text="Privacy Policy"
                    style="text-align:left"
                    doLocalizeText={false}
                />
            </div>
        </div>
    </aside>
    <main>
        <div class="pad-20">
            {#if optionsRoute == PRIVACY}
                <PrivacyPolicy />
            {/if}
            {#if optionsRoute == LICENSE}
                <License />
            {/if}
        </div>
    </main>
</div>

<style>
    main {
        /* Wider to allow for longer mod descriptions */
        max-width: 1200px;
        width: 100%;
        margin: 0 80px;
        background-color: white;
        color: black;
    }
    aside {
        max-width: 260px;
    }
</style>
